<template>
  <div class="d-flex justify-space-between align-center text-center bg-white mt-2" style="width: 100%">
    <div>
      <!-- <v-btn text color="primary" class="navigation-button" @click="subtractDay"> -->
      <v-btn variant="text" color="primary" class="navigation-button" @click="subtractDay">
        <v-icon start>mdi-chevron-left</v-icon>
        <v-badge
          color="primary"
          :content="`${beforeTheDate}`"
          v-if="beforeTheDate > 0"
          inline
        >
          {{ $t('date.previousDay') }}
        </v-badge>
        <div v-else>
          {{ $t('date.previousDay') }}
        </div>
      </v-btn>
    </div>
    <div>
      <div v-if="isYear" class="text-caption font-weight-bold">{{ todayYear }}</div>
      <div class="text-h6 font-weight-bold">{{ todayDate }} ({{ todayDayWeek }})</div>
    </div>
    <div>
      <v-btn variant="text" color="primary" class="navigation-button" @click="addDay">
        <v-badge
          color="primary"
          :content="`${afterTheDate}`"
          v-if="afterTheDate > 0"
          inline
        >
          {{ $t('date.nextDay') }}
        </v-badge>
        <div v-else>
          {{ $t('date.nextDay') }}
        </div>
        <v-icon end>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script lang="ts">
import Vue, { PropType, defineComponent } from 'vue';

import { NurseryClassResponse } from 'chaild-api/lib/index';

import LocalDataService from '@/service/LocalDataService';
import dayjs from 'dayjs';
import { i18n } from '@/plugins/i18n';

export default defineComponent({
  components: {},
  data: () => {
    return {};
  },
  props: {
    date: {
      type: Object as PropType<any>,
      required: true,
    },
    isYear: {
      type: Boolean,
      default: true,
    },
    beforeTheDate: {
      type: Number,
      default: 0,
    },
    afterTheDate: {
      type: Number,
      default: 0,
    }
  },
  computed: {
    currentLocale() {
      return i18n.global.locale.value;
    },
    todayDate() {
      const locale = this.currentLocale;
      if (locale === 'vi') {
        return this.date.format('D/M'); // 8/3
      } else if (locale === 'en') {
        return this.date.format('D/M'); // 8/3
      } else {
        return this.date.format('M月D日'); // 3月8日
      }
    },
    todayDayWeek() {
      const locale = this.currentLocale;
      const dayIndex = this.date.day(); // 0-6 (Sunday-Saturday)
      const daysVi = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];
      const daysEn = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const daysJa = ['日', '月', '火', '水', '木', '金', '土'];
      
      if (locale === 'vi') {
        return daysVi[dayIndex];
      } else if (locale === 'en') {
        return daysEn[dayIndex];
      } else {
        return daysJa[dayIndex];
      }
    },
    todayYear() {
      const locale = this.currentLocale;
      if (locale === 'vi') {
        return `Năm ${this.date.format('YYYY')}`;
      } else if (locale === 'en') {
        return this.date.format('YYYY');
      } else {
        return this.date.format('YYYY年');
      }
    },
  },
  methods: {
    addDay() {
      this.$emit('addDay');
    },
    subtractDay() {
      this.$emit('subtractDay');
    },
  },
  async mounted() {},
});
</script>
<style lang="scss" scoped>
.text-h6 {
  @media (max-width: 430px) {
    white-space: nowrap;
    font-size: 0.75rem !important;
  }
}

.navigation-button {
  @media (max-width: 430px) {
    font-size: 0.75rem;
  }
}
</style>
